import { ProviderCredentialV2FormData } from '../../../integrated-client/models/ProviderCredentialV2FormData';

export interface IProviderCredentialsV2EditorData extends ProviderCredentialV2FormData {
  disabled?: boolean;
}

export interface IEditorData {
  providerCredentialsV2EditorData: IProviderCredentialsV2EditorData;
  validation?: any;
  readyToSave: boolean;
}

export class ProviderCredentialsV2EditorData implements IProviderCredentialsV2EditorData {
  disabled?: boolean;
  allowEdit?: boolean;
  enabled?: boolean;

  constructor() {   
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  providerCredentialsV2EditorData: IProviderCredentialsV2EditorData;
  validation?: any;
  readyToSave: boolean;

  constructor() {
    this.providerCredentialsV2EditorData = new ProviderCredentialsV2EditorData();
    this.readyToSave = false;
  }
}
